
















import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker,
} from 'element-ui';
import MyNav from '@/components/nav/Index.vue'; // nav
import NProgress from 'nprogress';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import Read from '../../servers/modules/read/read'; // server
import learning from './studyModel/learning.vue';
import race from './studyModel/race.vue';
import academic from './studyModel/academic.vue';

Vue.use(Loading.directive);
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Scrollbar,
        Button,
        DatePicker,
        learning,
        race,
        academic,
      },
    })
export default class extends Vue {
        @Mutation public setSkeletonDescribe;

        @Mutation public setNavData;

        @Getter public navData: any;

        @Getter public skeleton: any;

        @Getter public vteBasicData: any;

        // 左侧菜单栏
        @Getter public scaleCommonIndex: any;

        private operat: number = 1;

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }

        private created() {
          if (this.$route.query.operat) {
            this.operat = +this.$route.query.operat;
            console.log(this.operat);
          }
          console.log(333);
          console.log(this.operat);
          this.setSkeletonDescribe(true);
          NProgress.start();
          NProgress.done();
          this.setSkeletonDescribe(false);
        }

        // 切换下方表格
        private changeTable(type:string) {
          this.operat = type;
        }


        // 时间选择器
        private startTime: any = '';

        private endTime: any = '';

        private startTimeDate(time) {
          if (this.endTime) {
            return time.getTime() >= new Date(this.endTime).getTime();
          }
          return false;
        }

        private endTimeDate(time) {
          if (this.startTime) {
            return time.getTime() <= new Date(this.startTime).getTime();
          }
          return false;
        }

        private change() {
          this.$refs.learning.initLoad(this.startTime, this.endTime);
        }
}
